module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/cards/social-card/social-card.component.scss
// module id = ./src/app/shared/components/cards/social-card/social-card.component.scss
// module chunks = main